import { FC } from "react";
import { StatusFilterChips, type StatusFilterOption } from "@/ui";
import { KANBAN_LANES } from "config/constant";
import { useOrdersData } from "../../context/OrdersDataContext";

const STATUS_ORDER = [
    "PENDING",
    "APPROVED",
    "READY",
    "ASSIGNED",
    "DELIVERED",
    "VOID",
    "DECLINED",
    "REFUNDED",
    "DELIVERY_STARTED",
    "DELIVERY_FINISHED",
];

const allStatuses = new Set<string>();
Object.values(KANBAN_LANES).forEach(props => {
    const statuses = Array.isArray(props.status)
        ? props.status
        : [props.status];
    statuses.forEach(s => allStatuses.add(s));
});

export const STATUS_OPTIONS: StatusFilterOption[] = STATUS_ORDER.filter(s =>
    allStatuses.has(s),
).map(value => ({
    value,
    label: value.replace(/_/g, " "),
}));

export const OrdersStatusFilter: FC = () => {
    const { filterState, setFilterState } = useOrdersData();
    const selected = filterState.status || [];

    const handleSelect = (value: string | null) => {
        setFilterState(prev => ({
            ...prev,
            // only one active status at a time; null clears
            status: value ? [value] : [],
        }));
    };

    return (
        <StatusFilterChips
            onSelect={handleSelect}
            options={STATUS_OPTIONS}
            selected={selected}
            showAll
        />
    );
};
